import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81b54054&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=81b54054&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b54054",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTitle: require('/opt/build/repo/components/PageTitle.vue').default,HeaderMedia: require('/opt/build/repo/components/HeaderMedia.vue').default,ApiContent: require('/opt/build/repo/components/ApiContent.vue').default})
